import React from 'react';
import { translate } from 'react-i18next';
import VehicleDetailsCollapse from './VehicleDetailsCollapse';
import VehicleDetailsLabelAndValue from './VehicleDetailsLabelAndValue';
import CBMediaQuery from '../../shared/CBMediaQuery';
import { getStyle, formatDate, SERVICE_FLEET, SERVICE_WORKSHOP } from '../../../utils/utils';
import KeyValueEditorModal from '../../shared/KeyValueEditorModal';
import CBButtonGarageAction from '../../shared/CBButtonGarageAction';
import {
  updateOrganizationVehicle as _updateOrganizationVehicle,
} from '../../../actions/vehicleActions';
import { connect } from 'react-redux';
import { isUnregistered } from '../../../utils/equipment';
import EditTechnicalDataModal from './Modal/EditTechnicalDataModal';

class VehicleDetailsBasicContent extends React.Component {
  state = {
    modalIsOpen: false,
    technicalDataModalIsOpen: false,
  }

  renderTechnicalDataModal = () => {
    const { vehicle } = this.props;
    const { technicalDataModalIsOpen } = this.state;
    if (!technicalDataModalIsOpen) return null;
    return (
      <EditTechnicalDataModal
        modalIsOpen={technicalDataModalIsOpen}
        closeModal={() => this.setState({ technicalDataModalIsOpen: false })}
        vehicle={vehicle}
      />
    );
  }

  renderTechnicalDataButton = (screenSize) => {
    const { t } = this.props;
    return (
      <div style={getStyle(screenSize, styles, 'buttonContainer')}>
        <CBButtonGarageAction
          mainIcon='/img/icon_edit.svg'
          additionalStylesMainIcon={{ height: 25, width: 25 }}
          text={t('editTechnicalData')}
          onClick={() => this.setState({ technicalDataModalIsOpen: true })}
        />
      </div>
    );
  }

  /**
   * An unregistered asset has no Traficom content at all, so the two registry
   * sections would render as a wall of empty rows with a "source: Traficom"
   * footer under them. The manually entered equipment data takes their place.
   */
  renderEquipmentInfo = (screenSize) => {
    const { t, vehicle, service } = this.props;

    return (
      <React.Fragment>
        <VehicleDetailsCollapse open title={t('equipmentInfoHeading')}>
          <VehicleDetailsLabelAndValue
            label={t('equipmentChassisLabel')}
            value={vehicle.platform_number}
          />
          <VehicleDetailsLabelAndValue
            label={t('manufacturerLabel')}
            value={vehicle.manufacturer}
          />
          <VehicleDetailsLabelAndValue
            label={t('modelLabel')}
            value={vehicle.model_name}
          />
          <VehicleDetailsLabelAndValue
            label={t('yearModelLabel')}
            value={vehicle.year_model}
          />
          {
            // Neither the add dialog nor the edit dialog has a field for the
            // motive power or the introduction date yet, so those two rows
            // only appear when the record already carries a value.
            !!vehicle.engine_motive_power && (
              <VehicleDetailsLabelAndValue
                label={t('engineMotivePowerLabel')}
                value={t(`motivePower:${vehicle.engine_motive_power}`)}
              />
            )
          }
          <VehicleDetailsLabelAndValue
            label={t('enginePowerLabel')}
            value={vehicle.engine_power}
          />
          <VehicleDetailsLabelAndValue
            label={t('ownMassLabel')}
            value={vehicle.own_mass}
          />
          <VehicleDetailsLabelAndValue
            label={t('dimensionsLabel')}
            value={[vehicle.length, vehicle.width, vehicle.height].filter(Boolean).join(' / ')}
          />
          {
            !!vehicle.introduction_date && (
              <VehicleDetailsLabelAndValue
                label={t('initialRegistrationLabel')}
                value={formatDate(vehicle.introduction_date)}
              />
            )
          }
          {
            // The machine's identity is the owning fleet's to edit. A workshop
            // or chain serving it can see it but not rename it.
            vehicle.can_edit && service === SERVICE_FLEET && this.renderTechnicalDataButton(screenSize)
          }
        </VehicleDetailsCollapse>
      </React.Fragment>
    );
  }

  onSubmitOrganizationData = (data) => {
    const { vehicle, updateOrganizationVehicle, selectedOrganizationId, selectedWorkshopId } = this.props;
    updateOrganizationVehicle(vehicle.id, {organization_data: {...vehicle.organization_data, data}}, vehicle.organization_id, selectedWorkshopId || null);
  }

  render() {
    const { t, vehicle, service } = this.props;
    const { modalIsOpen } = this.state;
    // The fleet and workshop portals edit the model data here; the personal
    // portal keeps it in "Muuta tietoja", which has nothing else to show there.
    const canEditModelData = vehicle.can_edit && (service === SERVICE_FLEET || service === SERVICE_WORKSHOP);
    const insuranceString = `${vehicle.insurance_company} \
      ${formatDate(vehicle.insurance_start_date)}`;
    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'mainContentContainer')}>
            {isUnregistered(vehicle) && this.renderEquipmentInfo(screenSize)}
            {!isUnregistered(vehicle) && (
            <VehicleDetailsCollapse open title={t('basicInfoHeading')}>
              <VehicleDetailsLabelAndValue
                label={t('manufacturerLabel')}
                value={vehicle.manufacturer}
              />
              {/* <VehicleDetailsLabelAndValue label={t('vehicleStateLabel')} value='Placeholder' /> */}
              <VehicleDetailsLabelAndValue
                label={t('vehicleClassLabel')}
                value={vehicle.vehicle_class}
              />
              <VehicleDetailsLabelAndValue
                label={t('productNumberLabel')}
                value={vehicle.platform_number}
              />
              <VehicleDetailsLabelAndValue
                label={t('initialRegistrationLabel')}
                value={formatDate(vehicle.initial_registration_date)}
              />
              <VehicleDetailsLabelAndValue label={t('typeNameLabel')} value={vehicle.type_name} />
              <VehicleDetailsLabelAndValue
                label={t('certTechnicalNumberLabel')}
                value={vehicle.cert_technical_running_number}
              />
              <VehicleDetailsLabelAndValue
                label={t('certReportNumberLabel')}
                value={vehicle.cert_report_running_number}
              />
              <VehicleDetailsLabelAndValue
                label={t('typeAcceptNumberLabel')}
                value={vehicle.type_accept_number}
              />
              <VehicleDetailsLabelAndValue label={t('variantLabel')} value={vehicle.variant} />
              <VehicleDetailsLabelAndValue label={t('versionLabel')} value={vehicle.version} />
              <VehicleDetailsLabelAndValue label={t('usageLabel')} value={vehicle.usage_display} />
              <VehicleDetailsLabelAndValue label={t('insurance')} value={insuranceString} />
              <VehicleDetailsLabelAndValue label={t('traficomSyncDate')} value={formatDate(vehicle.traficom_sync_date) || '-'} />
              {canEditModelData && this.renderTechnicalDataButton(screenSize)}
              <div style={getStyle(screenSize, styles, 'traficomSource')}>
                {t('traficomSource')}
              </div>
            </VehicleDetailsCollapse>
            )}
            {this.renderTechnicalDataModal()}

            {!isUnregistered(vehicle) && (
            <VehicleDetailsCollapse open={false} title={t('motorInfoHeading')}>
              <VehicleDetailsLabelAndValue
                label={t('engineCapacityLabel')}
                value={vehicle.engine_displacement}
              />
              <VehicleDetailsLabelAndValue
                label={t('engineMotivePowerLabel')}
                value={t(`motivePower:${vehicle.engine_motive_power}`)}
              />
              <VehicleDetailsLabelAndValue
                label={t('enginePowerLabel')}
                value={vehicle.engine_power}
              />
              <VehicleDetailsLabelAndValue
                label={t('enginePowerMassRatioLabel')}
                value={vehicle.engine_power_mass_ratio}
              />
              <VehicleDetailsLabelAndValue
                label={t('engineNoiseDriveByLabel')}
                value={vehicle.engine_noise_drive_by}
              />
              <VehicleDetailsLabelAndValue
                label={t('engineNoiseStaticLabel')}
                value={vehicle.engine_noise_static}
              />
              <div style={getStyle(screenSize, styles, 'traficomSource')}>
                {t('traficomSource')}
              </div>
            </VehicleDetailsCollapse>
            )}

            {
              !vehicle.is_personal_vehicle && (
                <VehicleDetailsCollapse open={false} title={t('organizationInfoHeading')}>
                  {
                    vehicle.organization_data && Object.entries(vehicle.organization_data.data).map(([key, value]) => (
                      <VehicleDetailsLabelAndValue
                        label={key}
                        value={value}
                      />
                    ))
                  }
                  <div style={getStyle(screenSize, styles, 'buttonContainer')}>
                    <CBButtonGarageAction
                      mainIcon='/img/icon_edit.svg'
                      additionalStylesMainIcon={{ height: 25, width: 25 }}
                      text={t('editData')}
                      onClick={() => this.setState({ modalIsOpen: true })}
                      disabled={vehicle.user_role === 'employee'}
                      />
                  </div>
                </VehicleDetailsCollapse>
              )
            }
            {
              modalIsOpen && (
                <KeyValueEditorModal
                  modalIsOpen={modalIsOpen}
                  closeModal={() => {this.setState({ modalIsOpen: false });}}
                  afterOpenModal={() => {}}
                  title={t('editCompanyVehicleData')}
                  initialData={vehicle.organization_data ? vehicle.organization_data.data : {}}
                  onSubmit={this.onSubmitOrganizationData}
                />
              )
            }
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    buttonContainer: {
      marginTop: 16,
      marginBottom: 16,
    },
    mainContentContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexDirection: 'column',
      backgroundColor: 'rgba(0, 149, 218, 1)',
      minHeight: 500,
      width: '75%',
    },
    traficomSource: {
      fontFamily: 'TitilliumWeb-Regular',
      color: '#ffffff',
      textDecoration: 'none solid rgb(255, 255, 255)',
      fontSize: 12,
      textAlign: 'right',
      paddingTop: 11,
      paddingRight: 20,
      paddingBottom: 16,
    }
  },
  small: {
    mainContentContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexDirection: 'column',
      backgroundColor: 'rgba(0, 149, 218, 1)',
      minHeight: 500,
      width: '100%',
    },
  },
};

function mapStateToProps(state) {
  return {
    selectedOrganizationId: state.organization.selectedOrganization,
    selectedWorkshopId: state.workshop.selectedWorkshop,
    service: state.app.service,
  };
}

export default connect(
  mapStateToProps,
  {
    updateOrganizationVehicle: _updateOrganizationVehicle,
  },
)(translate('VehicleDetailsView')(VehicleDetailsBasicContent));
